import { useEffect, useState } from "react"
import UnveilPreview from "./unveil/unveil"
import {
  fetchTHPRegistrants,
  fetchBBBRegistrants,
  fetchPopMyCherryRegistrants,
  fetchVTCRegistrants
} from '../api/adminService';
import { usePage } from "../contexts/PageContext"
import { Toast } from "../components/Toast";
import { checkUserExists } from "./unveil/utils/userService";


export default function UnveilPage() {
  const [message, setMessage] = useState("Processing QR code...")
  const [showSearch, setShowSearch] = useState(false);
  const [result, setResult] = useState(null);
  const [dataType, setdataType] = useState(null);
  const [portals, setPortals] = useState([]);

  // useEffect(() => {
  //   handleStartUp();
  // }, []);

  useEffect(() => {
    const fetchAllPortals = async () => {
    setResult({ status: "loading", user: null, message: "Loading all Users" });
      const [thp, bbb, pmc, vtc] = await Promise.all([
        fetchTHPRegistrants(),
        fetchBBBRegistrants(),
        fetchPopMyCherryRegistrants(),
        fetchVTCRegistrants()
      ]);

      setPortals([
        { portal: "The Healing Party", data: thp },
        { portal: "Birthday Bible Brunch", data: bbb },
        { portal: "Pop My Cherry", data: pmc },
        { portal: "Teens Virtual Camp", data: vtc }
      ]);
    };

    fetchAllPortals();
  }, []);

  // ✅ This effect will run AFTER portals is updated
  useEffect(() => {
    if (portals.length > 0) {
      handleStartUp();
    }
  }, [portals]);

  const handleStartUp = () => {
    const searchParams = new URLSearchParams(window.location.search);
    const code = searchParams.get("code");
    setResult({ status: "loading", user: null, message: "Loading" });

    if (!code) {
      setShowSearch(true);
      setResult(null);
      setdataType("user");
      return;
    }

    const [prefix, rest] = code.split(":");
    const parts = rest?.split("/") || [];
    const userId = parts[1];

    if (!userId) {
      setShowSearch(true);
      setResult(null);
      return;
    }

    switch (prefix?.toLowerCase()) {
      case "thp":
        setdataType("thp");
        _fetchTHPData(userId);
        break;
      case "bbb":
        setdataType("bbb");
        // fetchBBBData(userId);
        break;
      default:
        setResult({
          status: "table_not_found",
          user: null,
          message: "Hmm... this QR code doesn’t seem to lead anywhere we know"
        })
        setMessage("Hmm... this QR code doesn’t seem to lead anywhere we know.");
        break;
    }
  }


  const _fetchTHPData_ = async (idString) => {
    const portalToCheck = portals.filter(value => value.portal === "The Healing Party")


    try {
      const searchResult = await checkUserExists(portalToCheck, idString.trim());
      setResult(searchResult);
    } catch (error) {
      setResult({
        status: 'error',
        message: 'An unexpected error occurred. Please try again: ' + error
      });
    }
  };

  const _fetchTHPData = async (idString) => {
    let portalToCheck = portals.filter(value => value.portal === "The Healing Party");

    // If empty, wait 5s and recheck
    if (portalToCheck.length === 0) {
      await new Promise(resolve => setTimeout(resolve, 5000));
      portalToCheck = portals.filter(value => value.portal === "The Healing Party");
    }

    try {
      const searchResult = await checkUserExists(portalToCheck, idString.trim());
      setResult(searchResult);
    } catch (error) {
      setResult({
        status: "error",
        message: "An unexpected error occurred. Please try again: " + error
      });
    }
  };



  // const fetchBBBData = async (idString) => {
  //   setdataType("bbb");
  //   // try {
  //   //   const response = await fetch(`/api/bbb/${encodeURIComponent(idString)}`)
  //   //   const data = await response.json()

  //   //   if (data?.valid) {
  //   //     setData(data)
  //   //   } else {
  //   //     setMessage("This BBB code is not valid or has already been used.")
  //   //   }
  //   // } catch (err) {
  //   //   setMessage("Couldn’t process your BBB code. Try again.")
  //   // }
  // }

  //   if (vipData) {
  //     return (
  //       <div className="min-h-screen flex items-center justify-center p-8 bg-white text-center">
  //         <div className="bg-slate-100 p-6 rounded-xl shadow-xl">
  //           <h1 className="text-2xl font-bold mb-2">VIP Access Confirmed 🎉</h1>
  //           <p className="text-slate-600">{vipData.message}</p>
  //         </div>
  //       </div>
  //     )
  //   }

  return (
    // <div className="min-h-screen flex items-center justify-center p-8 bg-white text-center">
    //   <div className="text-slate-600 text-lg">{message}</div>
    // </div>
    <UnveilPreview
      message={message} dataType={dataType}
      result={result} setResult={setResult} showSearch={showSearch}
      handleStartUp={handleStartUp}
      portals={portals}
    />
  )
}




async function fetchTHPData(idString) {
  const endpoint = 'https://tsoministries.com/wp-json/wp/v2/thp';
  let page = 1;
  let idExists = false;
  let user = null;

  try {
    while (true) {
      const response = await fetch(`${endpoint}?per_page=100&page=${page}&_fields=id,email_address,vip,first_name,surname`);

      if (!response.ok) {
        // If 400 and page > 1, assume we've reached the end
        if (response.status === 400 && page > 1) {
          break;
        }
        throw new Error(`Error fetching page ${page}`);
      }

      const data = await response.json();

      if (!Array.isArray(data) || data.length === 0) {
        break;
      }

      for (const item of data) {
        if (item.id && item.id.toLowerCase() === idString.toLowerCase()) {
          idExists = true;
          user = item;
          break;
        }
      }

      if (idExists || data.length < 100) {
        break;
      }

      page++;
    }

    return { idExists, user, error: false, message: "" } // true = available
  } catch (error) {
    const error_ = 'Failed to check user:' + error
    console.error('Failed to check email v2:', error);
    return { idExists: false, user: null, error: true, message: error_ };
  }
}